import * as React from "react";
import { Box, Typography, Chip, Stack, Table, TableHead, TableBody, TableRow, TableCell, Paper } from "@mui/material";
import { RemoteObject, fmtDate, fmtMoney } from "./RemoteList";

// Affiche le parrain (referrer) du user courant — endpoint séparé.
const ParrainBlock = () => (
  <RemoteObject
    buildPath={(r) => `/referral/users/${r.id}/referrer`}
    emptyText="Aucun parrain"
    render={(p) => {
      if (!p || !p.id) {
        return <Typography color="text.secondary" sx={{ p: 1 }}>Aucun parrain</Typography>;
      }
      const name = `${p.firstName || ""} ${p.lastName || ""}`.trim() || p.id;
      return (
        <Paper variant="outlined" sx={{ p: 1.5, mb: 2 }}>
          <Typography variant="caption" sx={{ fontWeight: 700, color: "text.secondary", textTransform: "uppercase" }}>
            Parrain
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>{name}</Typography>
          {p.email && <Typography variant="body2" color="text.secondary">{p.email}</Typography>}
        </Paper>
      );
    }}
  />
);

// Panneau Parrainage / Ambassadeur d'un user : parrain, code de parrainage,
// code ambassadeur, solde Ura, et liste des filleuls. Sources :
// GET /referral/users/{id}/referrer + GET /referral/dashboard?userId={id}.
export const ReferralPanel = () => (
  <Box>
    <ParrainBlock />
    <RemoteObject
    buildPath={(r) => `/referral/dashboard?userId=${r.id}`}
    emptyText="Aucune donnée de parrainage"
    render={(d) => {
      const referrals = Array.isArray(d.referrals) ? d.referrals : [];
      return (
        <Box sx={{ p: 1 }}>
          <Stack direction="row" spacing={2} sx={{ mb: 2, flexWrap: "wrap" }}>
            <Chip label={`Code parrainage : ${d.referralCode || "—"}`} />
            <Chip color="primary" label={`Code ambassadeur : ${d.ambassadorCode || "—"}`} />
            <Chip variant="outlined" label={`Ura : ${d.uraPoints ?? 0} (${fmtMoney(d.uraInEuros ?? 0)})`} />
            <Chip variant="outlined" label={`Filleuls : ${d.totalReferralsCount ?? referrals.length}`} />
            <Chip variant="outlined" label={`Taux : ${d.currentRatePercent ?? 0}%`} />
            <Chip variant="outlined" label={`CA parrainage : ${fmtMoney(d.totalAmountFromReferrals ?? 0)}`} />
          </Stack>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>Filleuls</Typography>
          {referrals.length === 0 ? (
            <Typography color="text.secondary">Aucun filleul</Typography>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Nom</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Parrainé le</TableCell>
                  <TableCell>Montant apporté</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {referrals.map((f, i) => (
                  <TableRow key={f.id || i} hover>
                    <TableCell>{`${f.firstName || ""} ${f.lastName || ""}`.trim() || "—"}</TableCell>
                    <TableCell>{f.email || "—"}</TableCell>
                    <TableCell>{fmtDate(f.referredAt)}</TableCell>
                    <TableCell>{fmtMoney(f.amountBrought ?? 0)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Box>
      );
    }}
  />
  </Box>
);

export default ReferralPanel;
